import React from 'react'
import {
  LoaderSwitcher,
  MerchantCategoriesLoader,
  MerchantLocationsLoader,
  LoyaltyOverviewLoader,
  LoyaltyCardsLoader
} from 'router/Loaders'
import Loyalty from 'components/Loyalty'
import {
  LoyaltyOverviewContext,
  SetupLoyaltyOverview
} from 'hooks/useGlobalContext/useLoyaltyOverview'
import {
  LoyaltyCardsContext,
  SetupLoyaltyCards
} from 'hooks/useGlobalContext/useLoyaltyCards'

// Mounts the Loyalty Context/Loader chain once per route, above the Loyalty tabs or `children`.
// Doing it here, rather than in GlobalContext, survives `destroyInactiveTabPane` unmounting the tabs.
interface LoyaltyWrapperProps {
  children?: React.ReactElement
}

export const LoyaltyWrapper = ({ children }: LoyaltyWrapperProps) => {
  const overviewState = SetupLoyaltyOverview()
  const cardsState = SetupLoyaltyCards()

  return (
    <LoyaltyOverviewContext.Provider value={overviewState}>
      <LoyaltyCardsContext.Provider value={cardsState}>
        <MerchantCategoriesLoader>
          {(isParentLoaded) => (
            <MerchantLocationsLoader isParentLoaded={isParentLoaded}>
              {(isParentLoaded) => (
                <LoyaltyOverviewLoader isParentLoaded={isParentLoaded}>
                  {(isParentLoaded) => (
                    <LoyaltyCardsLoader isParentLoaded={isParentLoaded}>
                      {(isParentLoaded) => (
                        <LoaderSwitcher isParentLoaded={isParentLoaded}>
                          {children ?? <Loyalty />}
                        </LoaderSwitcher>
                      )}
                    </LoyaltyCardsLoader>
                  )}
                </LoyaltyOverviewLoader>
              )}
            </MerchantLocationsLoader>
          )}
        </MerchantCategoriesLoader>
      </LoyaltyCardsContext.Provider>
    </LoyaltyOverviewContext.Provider>
  )
}
